import { render, staticRenderFns } from "./DateOutput.vue?vue&type=template&id=6f79eec1&"
import script from "./DateOutput.vue?vue&type=script&lang=ts&"
export * from "./DateOutput.vue?vue&type=script&lang=ts&"
import style0 from "./DateOutput.vue?vue&type=style&index=0&id=6f79eec1&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports